/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 50:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 65:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 77:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 7 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 50:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 62:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 7 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 20:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 35:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 7 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, $replaceContent } = await importModule('Utils');

    customElements.define('collection-provider', class extends Core {

        elements = {
            form: '[data-collection-form]',
            drawerForm: '[data-collection-drawer-form]',
            dynamicBlocks: '*[data-collection-dynamic-block]'
        }

        subscriptions = {
            'filter:change': '_onFilterChange',
            'navigation:change': '_onFilterChange'
        }

        cache = {};

        render() {
            this.subscribe('filter:change');
            this.subscribe('navigation:change');
        }
        
        async _onFilterChange(data) {
            this._getUrlParams(data);
            this._updateHistory();
            this._scrollToTop();
            await this._updateDynamicBlocks();
        }

        _getUrlParams(data) {
            this.urlParams = data?.url
                ? new URL(`${window.location.origin}${data.url}`).searchParams
                : new URLSearchParams(new FormData(this.$currentForm));
        }

        _updateHistory() {
            window.history.pushState({}, null, `${window.location.pathname}?${this.urlParams.toString()}`);
        }

        async _updateDynamicBlocks() {
            await this._getDoc();
            this.$dynamicBlocks.map($block => {
                $replaceContent(
                    $block,
                    this.doc.getElementById($block.id)
                );
            });
            
        }

        async _getDoc() {
            const urlParamsStr = this.urlParams.toString();
            if(this.cache[urlParamsStr]) {
                this.doc = this.cache[urlParamsStr];
            } else {
                this.publish('collection:loading');
                await this._fetchDoc(urlParamsStr);
            }
            this.publish('collection:updated', {
                doc: this.doc
            })
        }

        async _fetchDoc(urlParamsStr) {
            const fetchParams = new URLSearchParams(urlParamsStr);
            fetchParams.append('section_id', this.sectionId);
            this.doc = await fetchHTML(`${this.getAttribute('collection-url')}?${fetchParams.toString()}`);
            this.cache[urlParamsStr] = this.doc;
        }

        _scrollToTop() {
            window.scrollTo({
                top: this.topPoint,
                behavior: 'smooth',
            });
        }

        get topPoint() {
            const headerHeight = document.documentElement.style.getPropertyValue('--header-height')?.replace('px', '');
            return headerHeight ? this.offsetTop - headerHeight : this.offsetTop;
        }

        get $currentForm() {
            if(!this.$form) {
                return this.$drawerForm;
            }
            return this.onMobile ? this.$drawerForm : this.$form;
        }

        get onMobile() {
            return window.matchMedia('(max-width: 992px)').matches;
        }
    })
})();